import type { SVGProps } from "react";

export const GoogleFlights = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="300 150 700 750"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Flight</title>{" "}
    <defs>
      {" "}
      <linearGradient
        gradientTransform="matrix(1 0 0 -1 0 1034.6666)"
        gradientUnits="userSpaceOnUse"
        id="SVGID_1_"
        x1="657.1484"
        x2="947.777"
        y1="549.3411"
        y2="177.4323"
      >
        {" "}
        <stop offset="0.075" stopColor="#5694CE" />{" "}
        <stop offset="0.4997" stopColor="#5EA4EC" />{" "}
      </linearGradient>{" "}
    </defs>{" "}
    <g>
      {" "}
      <g>
        {" "}
        <path
          d="M877.8,251.2l-447.6,532C358.8,723.7,311.4,636,306,536.1c-10.4-191.2,137-354.7,329.2-365.2C727.1,165.9,812.5,196.8,877.8,251.2z"
          fill="#5593D8"
        />{" "}
        <path
          d="M1002.6,515.8c0.8,183.6-143.4,337.6-329.7,347.7c-14.3,0.8-28.4,0.7-42.3-0.2c-75.6-5-145.1-34.1-200.2-80.1l422.8-502.5l1.4-1.7l23.3-27.7c71.3,59.4,118.7,147.1,124.2,247C1002.4,504.1,1002.5,510,1002.6,515.8z"
          fill="#60A7F0"
        />{" "}
      </g>{" "}
      <polygon fill="#4C82BC" points="480.5,610.3 548.3,642.8 530.9,663.5 " />{" "}
      <path
        d="M1002.9,516c0.8,183.6-143.4,337.6-329.7,347.7c-14.3,0.8-28.4,0.7-42.3-0.2C589.7,785.1,531,663.6,531,663.6l302.8-359.9l0.3,0.3L1002.9,516z"
        fill="url(#SVGID_1_)"
      />{" "}
      <g>
        {" "}
        <g>
          {" "}
          <path
            d="M451.4,406.2l179.3,85.2l-80,110.2l-57.1-8.1l-13.1,16.8l67.8,32.5l35.6,64.9l15.6-17.3L584.6,632l92.2-96.1L741,460l68.2-80.6c10.7-12.7,18.7-27.7,22.8-44c2.1-8.1,3.2-16.6,2.1-23.8c-3.4-21.5-49.3-2.7-64.4,15c-15.1,17.7-75.5,89.4-75.5,89.4l-228.3-27.9L451.4,406.2z"
            fill="#ECECEC"
          />{" "}
          <polygon
            fill="#D1D1D1"
            points="796.1,694.3 782.3,710.7 676.8,536 741,460.1 "
          />{" "}
        </g>{" "}
        <polygon
          fill="#4C82BC"
          points="451.4,406.2 596,539.2 630.7,491.4 "
        />{" "}
      </g>{" "}
    </g>
  </svg>
);

export default GoogleFlights;
